/**
 * 部标机设备报警相关方法
 */
import {jtDeviceAlarmTypeData} from '@/constants/jtDeviceAlarm';
import {formatTime} from '@/utils/formatTime';

// 显示部标机设备报警类型
export const displayJtDeviceAlarm = (alarmData: any) => {
  let alarmGroup = '';
  let warningType = '';
  if (alarmData.adas) {
    alarmGroup = 'adas';
    warningType = `${alarmGroup}_${alarmData.adas.warningType}`;
  } else if (alarmData.blind) {
    alarmGroup = 'blind';
    warningType = `${alarmGroup}_${alarmData.blind.warningType}`;
  } else if (alarmData.driver) {
    alarmGroup = 'driver';
    warningType = `${alarmGroup}_${alarmData.driver.warningType}`;
  }
  if (alarmGroup && warningType) {
    const matchAlarmGroup =
      jtDeviceAlarmTypeData.find((item: any) => item.value === alarmGroup)
        ?.children || [];
    const matchAlarmLabel = matchAlarmGroup.find(
      (item: any) => item.value === warningType
    )?.label;
    return matchAlarmLabel || '';
  } else {
    return '';
  }
};

// 显示部标机设备报警类型，针对没有ContentMap的情况
export const displayJtDeviceAlarmV2 = (warn: { alarmType: number, warningType: number }) => {
  let alarmGroup = null;
  let warningTypeStr = ``;
  switch (warn.alarmType) {
    case 1:
      alarmGroup = jtDeviceAlarmTypeData.find((item: any) => item.value === 'adas');
      warningTypeStr = `adas_${warn.warningType}`;
      break;
    case 2:
        alarmGroup = jtDeviceAlarmTypeData.find((item: any) => item.value === 'driver');
        warningTypeStr = `driver_${warn.warningType}`;
      break;
    case 3:
        alarmGroup = jtDeviceAlarmTypeData.find((item: any) => item.value === 'blind');
        warningTypeStr = `blind_${warn.warningType}`;
      break;
    default:
      break;
  }
  const matchAlarmGroup = alarmGroup?.children || [];
  if (!matchAlarmGroup) {
    return '';
  }

  const matchAlarmLabel =matchAlarmGroup.find(
    (item: any) => item.value === warningTypeStr
  )?.label;

  return matchAlarmLabel || '';
};

export const getAlarmTypeValueFromCode = (warn:{alarmType: number, warningType: number}) => {
  let alarmGroup = '';
  let warningType = '';
  switch (warn.alarmType) {
    case 1:
      alarmGroup = 'adas';
      break;
    case 2:
      alarmGroup = 'driver';
    
      break;
    case 3:
      alarmGroup = 'blind';
      break;
    default:
      break;
  }
  warningType = `${alarmGroup}_${warn.warningType}`;

  return [alarmGroup, warningType];

}

export const getAlarmTypeCodeFromValue = (value: string[]) => {
  const alarmGroup = value[0];
  const warningType = value[1];
  let alarmType = 0;
  let warningTypeCode = 0;
  switch (alarmGroup) {
    case 'adas':
      alarmType = 1;
      break;
    case 'driver':
      alarmType = 2;
      break;
    case 'blind':
      alarmType = 3;
      break;
    default:
      break;
  }
  const warningTypeArr = warningType.split('_');
  if (warningTypeArr.length > 1) {
    warningTypeCode = parseInt(warningTypeArr[1], 10);
  }

  return [alarmType, warningTypeCode];
}

/**
 * 显示部标机设备报警时间或速度（兼容没有报警详细信息时显示外层数据）
 * @param alarmData 报警数据
 * @param innerKey 有报警详细信息时使用的字段key
 * @param outerKey 没有报警详细信息时使用的字段key
 * @param format 是否需要格式化显示时间
 */
export const displayJtDeviceInfo = (
  alarmData: any,
  innerKey: string,
  outerKey: string,
  format?: boolean
) => {
  let alarmGroup = '';
  if (alarmData.contentMap?.adas) {
    alarmGroup = 'adas';
  } else if (alarmData.contentMap?.blind) {
    alarmGroup = 'blind';
  } else if (alarmData.contentMap?.driver) {
    alarmGroup = 'driver';
  }
  if (alarmGroup) {
    const matchValue = alarmData.contentMap?.[alarmGroup]?.[innerKey];
    return format ? formatTime(matchValue) : matchValue;
  } else {
    const matchValue = alarmData[outerKey];
    return format ? formatTime(matchValue) : matchValue;
  }
};
